module.exports = __webpack_public_path__ + "img/Mudas infectadas por Neonectria ditissima oriundas do viveiro 1.141cfd2c.webp";